<script>
import LegalAgreementsLatestDownloadBtnVue from '../components/LegalAgreementsLatestDownloadBtn.vue';

export default {
  name: 'LegalContractLatestDownload',
  extends: LegalAgreementsLatestDownloadBtnVue,
  data: () => ({
    type: 'NewSgvOnboardingContract',
  }),
};
</script>
